import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { NotificationService } from 'app/_services/notification.service';
import { SellerOrderService } from '../_services/order.service';
import { SettingsService } from 'app/_services/settings.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Globals } from 'app/_models/globals';
import { NotaFiscal, PedidoNotaFiscal } from 'app/_componentes/notafiscal/_models/pedidonotafiscal';
import { SellerDashboardPostUploadNotaFiscalResponseModel } from './_models/sellerDashboardPostUploadNotaFiscalResponseModel';

declare const $: any;
declare const isEmpty: any;

@Injectable({ providedIn: 'root' })
export class SellerDashboardService extends BaseService {
    private _domain: string = '/seller/dashboard';
    private _domainSellerOrders: string = '/seller/orders';

    constructor(
        private sellerOrderService: SellerOrderService,
        private notificationService: NotificationService,
        private config: SettingsService,
        private globals: Globals) {
        super();
    }

    public excluirNF(nota_url: any, pedido: any, callback: any) {
        pedido.loadingNF = true;

        this.sellerOrderService.removeNotaFiscal(pedido.order_id, nota_url).subscribe({
            next: () => {
                let indice = pedido.notasFiscais.findIndex(n => n.url === nota_url);
                pedido.notasFiscais.splice(indice, 1);

                if (pedido.notasFiscais.length <= 0)
                    pedido.tem_nota_fiscal = false;

                this.notificationService.showSuccessToastr(this.globals.translate('componente.nota-fiscal.mensagens.sucesso.excluir.corpo'));
                pedido.loadingNF = false;

                this.montarNFPedido(pedido);

                if (typeof callback === 'function')
                    callback();
            },
            error: async (error) => {
                pedido.loadingNF = false;
                console.log(error);
                await this.notificationService.showWarning('componente.nota-fiscal.mensagens.erro.excluir.corpo', 'componente.nota-fiscal.mensagens.erro.excluir.titulo');
            }
        });
    }

    public async incluirNF($event: any, pedido: any, nfComponent: any, callback: any, callbackAtualizarPedido: any, callbackStopLoader: any) {
        pedido.loadingNF = true;

        let fileUpload = $event.target;
        var file = fileUpload.files[0];
        var b64file = (await this.toBase64(file)).toString();
        b64file = b64file.indexOf(',') > -1 ? b64file.split(',')[1] : b64file;

        if (file.name.toLowerCase().indexOf('.xml') < 0 && file.name.toLowerCase().indexOf('.pdf') < 0) {
            pedido.loadingNF = false;
            await this.notificationService.showWarning('seller.nota-fiscal.mensagens.erro.incluir-extensao.corpo', 'seller.nota-fiscal.mensagens.erro.incluir-extensao.titulo');
            return;
        }

        this.sellerOrderService.uploadNotaFiscal(pedido.order_id, b64file, file.name).subscribe({
            next: async (response: ApiResponseModel<SellerDashboardPostUploadNotaFiscalResponseModel>) => {
                if (response.result.isProcessing) {
                    $(fileUpload).val('');
                    pedido.nf_em_processamento = true;
                    pedido.loadingNF = false;

                    this.notificationService.showWarningToastr('seller.notas-fiscais.processamento', { translateMessage: true })
                    callbackStopLoader(true);
                    return;
                }

                pedido.tem_nota_fiscal = true;
                pedido.tem_inconsistencias = response.result.temInconsistencias;

                if (isEmpty(pedido.notasFiscais))
                    pedido.notasFiscais = [];

                pedido.notasFiscais.push(response.result.notaFiscal);
                this.notificationService.showSuccessToastr(this.globals.translate('seller.nota-fiscal.mensagens.sucesso.incluir.corpo'));

                if (nfComponent)
                    nfComponent.selecionarNota(response.result.notaFiscal);

                if (typeof callback === 'function')
                    callback(pedido);

                if (typeof callbackAtualizarPedido === 'function')
                    callbackAtualizarPedido();

                $(fileUpload).val('');
                pedido.loadingNF = false;

                this.montarNFPedido(pedido);
            },
            error: async (error) => {
                pedido.loadingNF = false;
                console.log(error);
                await this.notificationService.showWarning('seller.nota-fiscal.mensagens.erro.incluir.corpo', 'seller.nota-fiscal.mensagens.erro.incluir.titulo');
                $(fileUpload).val('');
                callbackStopLoader(false);
            }
        });
    }

    public getDashboard(): Observable<any> {
        return this.config.executeGet({ url: `${this._domain}` });
    }

    public montarNFPedido(pedido) {
        if (!isEmpty(pedido) && !isEmpty(pedido.notasFiscais)) {
            let notasFiscais: NotaFiscal[] = pedido.notasFiscais.map((nf) => { return { numero: nf.numero, url: nf.url, shipping_company_id: nf.shipping_company_id, shipping_company_name: nf.shipping_company_name, shipping_company_tracking_code: nf.shipping_company_tracking_code } });
            let lista: PedidoNotaFiscal = { quotation_id: pedido.quotation_id, can_upload_nf: pedido.can_upload_nf, notasFiscais };

            pedido.pedidoNFs = lista;
        }
    }

    public setShippingCompany(pedido, dadosTransportadora, callback) {
        pedido.loadingNF = true;

        this.setShippingCompanyExecution(pedido.order_id, dadosTransportadora).subscribe({
            next: () => {
                this.notificationService.showSuccessToastr(this.globals.translate('componente.nota-fiscal.mensagens.sucesso.salvar-transportadora.corpo'));
                pedido.loadingNF = false;

                const index = pedido.notasFiscais.findIndex(nf => nf.numero === dadosTransportadora.nota_fiscal);
                let item = Object.assign({}, pedido.notasFiscais[index]);
                item.shipping_company_id = dadosTransportadora.shipping_company_id;
                item.shipping_company_name = dadosTransportadora.shipping_company_name;
                item.shipping_company_tracking_code = dadosTransportadora.shipping_company_tracking_code;
                pedido.notasFiscais.splice(index, 1, item);

                this.montarNFPedido(pedido);

                if (typeof callback === 'function')
                    callback(pedido);
            },
            error: error => {
                pedido.loadingNF = false;
                console.log(error);
                this.notificationService.showErrorToastr(this.globals.translate('componente.nota-fiscal.mensagens.erro.salvar-transportadora.corpo'));
            }
        });
    }

    public setShippingCompanyExecution(orderId: number, dadosTransportadora: any): Observable<any> {
        const body = { dadosTransportadora };
        return this.config.executePost({ url: `${this._domainSellerOrders}/${orderId}/set-shipping-company`, body });
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
